<template>
  <b-container class="contentcontainer site-detail__audits">
    <b-row class="contentcontainer__head">
      <b-col>
        <h2>{{$t('site.latestaudits')}}</h2>
      </b-col>
    </b-row>
    <hr/>
    <b-row>
      <b-col>
        <div class="info">
          <div class="table-responsive-lg" v-if="siteDetail.data.audits && siteDetail.data.audits.length">

            <table class="table table--overview">
              <thead>
              <tr>
                <th>
                  {{$t('site.date')}}
                </th>
                <th>
                  {{$t('site.auditresult')}}
                </th>
                <th class="text-right">
                  {{$t('site.details')}}
                </th>
              </tr>
              </thead>

              <tbody>
                <site-detail-audit-item
                    v-for="item in siteDetail.data.audits"
                    :key="item.id"
                    v-bind="item"
                />
              </tbody>

              <tfoot v-show="showPagination">
              <tr>
                <td colspan="3">
                  <nav class="page navigation">
                    <b-pagination
                      align="center"
                      v-bind:total-rows="siteDetail.data.audits.length"
                      v-model="currentPage"
                      v-bind:per-page="limit"
                    >
                    </b-pagination>
                  </nav>
                </td>
              </tr>
              </tfoot>
            </table>
          </div>
          <div class="no-audits" v-else>
            <div class="text">
              <h2>
                {{$t('site.nositeauditsdetected')}}
              </h2>
              <p>
                {{$t('site.nositeauditsdetectedmessage')}}
              </p>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

import { mapState, mapGetters } from 'vuex'
import SiteDetailAuditItem from './SiteDetailAuditItem'

export default {

  name: 'AuditsSection',

  components: {
    SiteDetailAuditItem
  },

  props: {

    showFullListLink: {
      default: true
    },
    showBackLink: {
      default: false
    },
    limit: {
      default: 5
    },
    showPagination: {
      default: false
    }
  },

  computed: {
    ...mapGetters('progress', [
      'siteBackupProgress'
    ]),

    ...mapState('site', [
      'siteDetail'
    ])
  },

  data () {
    return {
      currentPage: 1,
      totalPages: 1
    }
  },

  watch: {},

  methods: {

    close () {
      this.$emit('close-detail')
    }
  }
}
</script>
